import settings from "./components/settings-page.vue"
import calender from "./components/calender-page.vue"
import home from "./components/home-page.vue"
import quran from "./components/quran-page.vue"
import adkar from "./components/adkar-page.vue"
import err from "./components/error-page.vue"

export const routss = [

    {path: "/settings", component: settings },
    {path: "/calender", component: calender },
    {path: "/", component: home },
    {path: "/quran", component: quran },
    {path: "/adkar", component: adkar },
    {path: "/error", component: err },
    {path: "*", redirect: "/error" }
];